import { CSSProperties, forwardRef } from 'react';
import { Control, FieldPath, FieldValues, UseControllerProps, useController } from 'react-hook-form';
import CountryComboBox from '../inputs/Select/CountryComboBox';

interface Props<T extends FieldValues = FieldValues, TName extends FieldPath<T> = FieldPath<T>> {
  className?: string;
  control: Control<T>;
  disabled?: boolean;
  includeTaxFreeZones?: boolean;
  helperText?: string;
  label: string;
  name: TName;
  required?: boolean;
  rules?: UseControllerProps<T, TName>['rules'];
  style?: CSSProperties;
  hideLabel?: boolean;
}

interface WithForwardRefTypeProps<
  T extends FieldValues = FieldValues,
  TName extends FieldPath<T> = FieldPath<T>,
> extends React.FC<Props<T, TName>> {
  <T extends FieldValues = FieldValues, TName extends FieldPath<T> = FieldPath<T>>(
    props: Props<T, TName>,
  ): ReturnType<React.FC<Props<T, TName>>>;
}

const CountryController: WithForwardRefTypeProps = forwardRef(
  (
    { className, control, disabled, helperText, includeTaxFreeZones, label, name, required, rules, style, hideLabel },
    ref?: React.Ref<HTMLDivElement>,
  ) => {
    const { field, fieldState } = useController({ name, control, rules });
    return (
      <CountryComboBox
        {...field}
        ref={ref}
        className={className}
        isDisabled={disabled}
        label={label}
        includeTaxFreeZones={includeTaxFreeZones}
        isRequired={required}
        isInvalid={fieldState.invalid}
        errorMessage={fieldState.error?.message}
        helpText={helperText}
        style={style}
        hideLabel={hideLabel}
      />
    );
  },
);

export default CountryController;
